import i18n, { TFunction } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { setLocale } from 'yup';

import globalEn from './en.json';
import nutritionsEn from '@/src/features/modules/dashboard/pages/nutritions/i18n/en.json';
import ingredientsEn from '@/src/features/modules/dashboard/pages/ingredients/i18n/en.json';
import homeEn from '@/src/features/modules/dashboard/pages/home/i18n/en.json';
import cTableEn from '@/src/features/_components/c-table/i18n/en.json';

export const resources = {
  en: {
    global: globalEn,
    nutritions: nutritionsEn,
    ingredients: ingredientsEn,
    home: homeEn,
    cTable: cTableEn,
  },
};

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

declare module 'react-i18next' {
  interface CustomTypeOptions {
    defaultNS: 'global';
    returnNull: false;
  }
}

export function buildYupLocale(_: unknown, t: TFunction): void {
  setLocale({
    mixed: {
      required: t('VALIDATION.REQUIRED', { ns: 'global' }),
    },
    number: {
      min: ({ min }) => t('VALIDATION.MIN_NUMBER', { ns: 'global', count: min }),
      max: ({ max }) => t('VALIDATION.MAX_NUMBER', { ns: 'global', count: max }),
    },
    string: {
      email: t('VALIDATION.EMAIL', { ns: 'global' }),
      min: ({ min }) => t('VALIDATION.MIN_STRING', { ns: 'global', count: min }),
      max: ({ max }) => t('VALIDATION.MAX_STRING', { ns: 'global', count: max }),
    },
  });
}

export const defaultNS = 'global';

i18n
  .use(initReactI18next)
  .init({
    ns: ['global', 'nutritions', 'ingredients', 'home', 'cTable'],
    defaultNS,
    resources,
    lng: 'en',
    returnNull: false,
    interpolation: {
      escapeValue: false,
    },
  }, buildYupLocale);

export default i18n;
